export default __webpack_public_path__ + "static/media/partner_img_09.3fa6721d.png";